<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <modal
    id="approve_creatives_for_specific_networks_confirmation_modal"
    :visible="visible"
    :title="capitalize($t('actions.approveCreatives'))"
    :body="capitalize($t('messages.approveCreativesForSpecificNetworksDescription'))"
    :button1-caption="capitalize($t('actions.yes'))"
    :button1-disabled="selectedNetworks.length === 0"
    :button2-caption="capitalize($t('actions.no'))"
    :button2-visible="true"
    @confirmed="() => modalConfirmationResolver(true)"
    @cancelled="() => modalConfirmationResolver(false)">
    <template #modal-after-text>
      <HSTable
        id="network_approval_list_table"
        ref="table"
        category="NetworkApproval"
        :is-loading="false"
        :enable-column-reorder="false"
        :allow-selection="true"
        :items="networks"
        :columns="columns"
        pagination
        @selection-changed="selectedNetworks = $event" />
    </template>
  </modal>
</template>

<script setup lang="ts">
  import { capitalize, ref, useTemplateRef } from 'vue';

  import Modal from '@/common/components/controls/Modal.vue';
  import HSTable from '@/common/components/controls/table/Table.vue';
  import TableColumn from '@/common/components/controls/table/TableColumn';
  import TableColumnTypes from '@/common/components/controls/table/TableColumnTypes';
  import { Network } from '@/common/models';
  import i18n from '@/vueI18n';

  interface IProps {
    networks: Network[];
  }

  const { networks } = defineProps<IProps>();

  const table = useTemplateRef<InstanceType<typeof HSTable>>('table');
  const visible = ref(false);
  const selectedNetworks = ref<Network[]>([]);
  const modalConfirmationResolver = ref<(confirm: boolean) => void>(null);

  const columns = ref({
    name: TableColumn.fromObject({
      label: capitalize(i18n.global.t('names.name', { n: 1 })),
      property: 'name',
      type: TableColumnTypes.string,
    }),
  });

  async function selectNetworksForApproval() {
    // Reset modal state
    selectedNetworks.value = [];
    visible.value = true;
    const promise = new Promise<boolean>((resolve) => {
      modalConfirmationResolver.value = resolve;
    });

    const confirmation = await promise;

    visible.value = false;
    if (confirmation) {
      return selectedNetworks.value;
    }
    return null;
  }

  defineExpose({ selectNetworksForApproval });
</script>

<style lang="scss" rel="stylesheet/scss">
  #app {
    #approve_creatives_for_specific_networks_confirmation_modal {
      .modal-body {
        overflow-y: auto;
      }
    }
  }
</style>
